module.exports = __webpack_public_path__ + "static/DUC_8566-01-square-2a8fc47e548f35ce54597a227d95c090.jpeg";